import { render, staticRenderFns } from "./WordItem.vue?vue&type=template&id=70bfc067"
import script from "./WordItem.vue?vue&type=script&lang=js"
export * from "./WordItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports